module.exports = __webpack_public_path__ + "img/logo3.12a64f43.png";